<template>
  <ErrorBlock :title="title" :label="label" :path="path" />
</template>
<script setup lang="ts">
import { ErrorTypes, Eva2Error } from '~/lib/errors/Eva2Error';
type Props = {
  error: Eva2Error;
};
const props = defineProps({
  error: null
});

const title = computed(() => {
  switch (props.error.type) {
    case ErrorTypes.ChallengeMissing:
      return `Ce challenge n'est plus disponible`;
    case ErrorTypes.Adam:
      return props.error.message;
    case ErrorTypes.CategoryMissing:
    case ErrorTypes.ContentNotFound:
    default:
      return `Ce contenu n'est plus disponible`;
  }
});
const label = computed(() => {
  switch (props.error.type) {
    case ErrorTypes.ChallengeMissing:
      return 'Retourner aux challenges';
    case ErrorTypes.CategoryMissing:
    case ErrorTypes.ContentNotFound:
    default:
      return "Retourner à la page d'accueil";
  }
});
const path = computed(() => {
  switch (props.error.type) {
    case ErrorTypes.ChallengeMissing:
      return '/challenges';
    default:
      return '/';
  }
});
</script>
